import clsx from 'clsx'
import { useRouter } from 'next/router'
import HamburgerIcon from '@ancon/wildcat-ui/shared/icons/menu.svg'

import Container from '../../container/Container'
import OutletSearchModal from '../../../../outlets/components/searchOutlets/OutletSearchModal'
import OrderFormatSelectionModal from '../../../../outlets/components/OrderFormatSelectionModal'
import ClientAuthContainer from '../../../../auth/components/ClientAuthContainer'
import useAppSelector from '../../../../../store/hooks/useAppSelector'
import {
  clientContextCustomerIdSelector,
  clientContextHasCompanyProfilesSelector,
  clientContextIsCompanyUserSelector,
} from '../../../../clientContext/store/clientContextSelectors'
import CustomerEvents from '../../../../../events/CustomerEvents'
import OrderProduct from '../../../../product/components/OrderProduct'
import DeleteOrderModal from '../../../../checkout/components/DeleteOrderModal'
import Button from '../../../../app/components/Button'
import useAppDispatch from '../../../../../store/hooks/useAppDispatch'
import { appSetIsMobileDrawerVisible } from '../../../../app/store/appSlice'
import GuestCustomerOnboardingModal from '../../../../checkout/components/guestCustomerOnboardingModal/GuestCustomerOnboardingModal'
import { Toaster } from '../../../../notification'
import SwitchLanguageModal from '../../../../app/components/language/SwitchLanguageModal'
import LocationPermissionModal from '../../../../location/components/LocationPermissionModal'
import ErrorModal from '../../../../app/components/errorModal/ErrorModal'
import isAppWhiteLabeled from '../../../../app/utils/isAppWhiteLabeled'
import OneSignalInitializer from '../../../../notification/components/OneSignalInitializer'
import useIsOrderRoute from '../../../../app/hooks/useIsOrderRoute'
import CheckoutCapacityConflictModal from '../../../../checkout/components/capacityConflict/CheckoutCapacityConflictModal'
import { AppRoutes } from '../../../../app/constants'

import styles from './MainNavbar.module.scss'
import NavActions from './NavActions'
import NavbarOutletSearch from './NavbarOutletSearch'
import MainNavbarBrand from './MainNavbarBrand'
import NavbarWorkspaceSwitcher from './NavbarWorkspaceSwitcher'

function MainNavbar() {
  const dispatch = useAppDispatch()
  const customerId = useAppSelector(clientContextCustomerIdSelector)
  const isCompanyUser = useAppSelector(clientContextIsCompanyUserSelector)
  const hasCompanyProfiles = useAppSelector(
    clientContextHasCompanyProfilesSelector,
  )
  const isWhiteLabeled = isAppWhiteLabeled()

  const isOrderRoute = useIsOrderRoute()
  const { pathname } = useRouter()

  const isRestaurantListRoute =
    pathname === AppRoutes.Home || pathname === AppRoutes.Outlets

  // Users who can order for a company always see who they are ordering for
  const showWorkspaceSwitcher = hasCompanyProfiles

  // The restaurant, format and time live in the step bar and the cart, and the
  // company overview in the switcher and company banner. Only the location
  // search stays in the top bar, on the restaurant list.
  const showLocationSearch = isRestaurantListRoute && !isCompanyUser

  function handleOpenMobileNavBar() {
    dispatch(appSetIsMobileDrawerVisible(true))
  }

  return (
    <nav
      className={clsx(styles.navContainer, {
        [styles.whiteLabeled]: isWhiteLabeled,
      })}
    >
      <Container fluid>
        <div className={styles.navLeftContainer}>
          {isOrderRoute && (
            <Button
              className={styles.navToggle}
              onClick={handleOpenMobileNavBar}
            >
              <HamburgerIcon />
            </Button>
          )}
          {!isWhiteLabeled && <MainNavbarBrand />}
          {showWorkspaceSwitcher && (
            <ClientAuthContainer fallbackSpinning={false}>
              <NavbarWorkspaceSwitcher />
            </ClientAuthContainer>
          )}
          {/* Popups */}
          <Toaster />
          {isOrderRoute && (
            <ClientAuthContainer fallbackSpinning={false}>
              {showLocationSearch && (
                <div className={styles.actionButtonWrapper}>
                  <NavbarOutletSearch />
                </div>
              )}
              {/* Modals */}
              <OutletSearchModal />
              <OrderFormatSelectionModal />
              <OrderProduct />
              <DeleteOrderModal />
              <GuestCustomerOnboardingModal />
              <SwitchLanguageModal />
              <LocationPermissionModal />
              <ErrorModal />
              <CheckoutCapacityConflictModal />
              {/* SignalR Listeners */}
              {customerId && <CustomerEvents />}
              {/* OneSignal */}
              {customerId && <OneSignalInitializer />}
            </ClientAuthContainer>
          )}
        </div>
        {isWhiteLabeled && (
          <div className={styles.navMiddleContainer}>
            <MainNavbarBrand />
          </div>
        )}
        <div className={styles.navRightContainer}>
          <div className={styles.navActions}>
            <NavActions />
          </div>
        </div>
      </Container>
    </nav>
  )
}

export default MainNavbar
